import axios from 'axios';
import { useAuthContext } from '../hooks/useAuthContext';
import { useLogout } from '../hooks/useLogout';
import { useState } from 'react';
import Modal from "react-modal";
import UpdateProfile from '../components/modals/UpdateProfileModal';

const Profile = () => {
    const [openProfileInfo, setOpenProfileInfo] = useState(false);
    const {logout} = useLogout();
    const {user} = useAuthContext();

    //create a stripe user portal and redirect user to the url provided by Stripe
    const handleSub = async () => {
        console.log('User from frontend: ' + user.userId);
        const response = await axios.post(
            process.env.REACT_APP_SERVER_URL + '/api/stripe/create-portal-session', 
            {userId: user.userId}
        );
        const portalUrl = response.data.portalUrl;
        //redirect user to portal session
        window.location.href = portalUrl;
    }


    //open update profile modal
    const handleUpdateProfileModal = () => {
        setOpenProfileInfo(true);
    }
    //close update profile modal
    const closeUpdateProfileModal = () => {
        setOpenProfileInfo(false);
    }

    const handleLogout = () => {
        logout();    
    }



    return (
        <div className="profile">
            <Modal
                isOpen={openProfileInfo}
                onRequestClose={closeUpdateProfileModal}
                contentLabel="Update Profile Info"
            >
                <div className="modal-header">
                    <h2>Profile Info</h2>
                    <button className="btn btn-light" onClick={closeUpdateProfileModal}>Close</button>
                </div>
                <UpdateProfile />
            </Modal>


            <button className='btn btn-light' onClick={handleSub}>Manage Subscription</button>
            <button className='btn btn-light' onClick={handleUpdateProfileModal}>Update Profile</button>
            <button className='btn btn-light' onClick={handleLogout}>Sign Out</button>
            <p>{user.email}</p>
        </div>
    )
}

export default Profile;